import { StatusBadge } from '@/components/common/StatusBadge';
import { BATCH_STAGE_LABEL, BATCH_STAGE_TONE } from '../constants/publish.constants';

interface BatchStageBadgeProps {
  stage: string;
}

export function BatchStageBadge({ stage }: BatchStageBadgeProps) {
  return (
    <StatusBadge tone={BATCH_STAGE_TONE[stage] ?? 'neutral'}>
      {BATCH_STAGE_LABEL[stage] ?? stage}
    </StatusBadge>
  );
}
